<template>
    <TopNavigation v-if="user" :appName="appName" :user="user"/>
    <main class="my-3">
        <div class="container-fluid" v-if="flashItem">
            <Alert :message="flash.message" :type="flash.type" @close="onCloseAlert"/>
        </div>
        <slot />
    </main>
</template>
<script setup lang="ts">
import TopNavigation from "@/components/widget/TopNavigation/TopNavigation.vue";
import type {FlashInterface, UserAuthInterface} from "@/components/helpers/Interfaces.ts";
import Alert from "@/components/elements/Alert.vue";
import {ref, toRefs, watch} from "vue";

const {flash, user, appName} = defineProps<{
    user?: UserAuthInterface,
    appName: string,
    flash?: FlashInterface
}>()

const flashItem = ref<FlashInterface | undefined>(flash)


watch(() => flash, (newVal) => {
    flashItem.value = newVal
})

const onCloseAlert = () => {
    flashItem.value = undefined
}

</script>
